import { render, staticRenderFns } from "./StrategyEditor.vue?vue&type=template&id=ebde3d2a&scoped=true"
import script from "./StrategyEditor.vue?vue&type=script&lang=js"
export * from "./StrategyEditor.vue?vue&type=script&lang=js"
import style0 from "./StrategyEditor.vue?vue&type=style&index=0&id=ebde3d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebde3d2a",
  null
  
)

export default component.exports